import { render, staticRenderFns } from "./DuplicateCheckReslut.vue?vue&type=template&id=071a569a&scoped=true"
import script from "./DuplicateCheckReslut.vue?vue&type=script&lang=js"
export * from "./DuplicateCheckReslut.vue?vue&type=script&lang=js"
import style0 from "./DuplicateCheckReslut.vue?vue&type=style&index=0&id=071a569a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a569a",
  null
  
)

export default component.exports